<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <!-- Admin -->
      <div class="grid_menu mb-5 pl-2" v-if="$store.state.status === 1">
        <!-- ประวัติการนับสต๊อก -->
        <v-card class="menu_team text-center" v-if="$store.state.userDetail.count_warehouse === 1 && data_stock.stock_status === 0 || $store.state.userDetail.count_warehouse === 1 && data_stock.stock_status === 1 || $store.state.userDetail.count_warehouse === 1 && data_stock.stock_status === 2">
          <router-link class="menu_team_link" to="/stock/count_warehouse/countlistwarehouse">
            <div class="menu_team_img">
              <img src="@/assets/supply.png">
            </div>
            <div>
              ประวัติการนับสต๊อก
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center" v-else disabled>
          <router-link class="menu_team_link" to="/stock/count_warehouse/countlistwarehouse">
            <div class="menu_team_img">
              <img src="@/assets/supply.png">
            </div>
            <div>
              ประวัติการนับสต๊อก
            </div>
          </router-link>
        </v-card>
        <!-- สร้างรอบนับ -->
        <v-card class="menu_team text-center" v-if="$store.state.userDetail.count_warehouse_create === 1 && data_stock.stock_status === 2">
          <router-link class="menu_team_link" to="/stock/count_warehouse/warehousecreate">
            <div class="menu_team_img">
              <img src="@/assets/clipboard_1.png">
            </div>
            <div>
              สร้างรอบนับ
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center" v-else disabled>
          <router-link class="menu_team_link" to="/stock/count_warehouse/warehousecreate">
            <div class="menu_team_img">
              <img src="@/assets/clipboard_1.png">
            </div>
            <div>
              สร้างรอบนับ
            </div>
          </router-link>
        </v-card>
        <!-- นับสต๊อก -->
        <v-card class="menu_team text-center mr-1" v-if="$store.state.userDetail.count_warehouse_count === 1 && data_stock.stock_status === 0">
          <router-link class="menu_team_link" to="/stock/count_warehouse/warehousecount">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              นับสต๊อก
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center mr-1" v-else disabled>
          <router-link class="menu_team_link" to="/stock/count_warehouse/warehousecount">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              นับสต๊อก
            </div>
          </router-link>
        </v-card>
      </div>
      <!-- Employee -->
      <div class="grid_menu mb-5 pl-2" v-else>
        <!-- ประวัติการนับสต๊อก -->
        <v-card class="menu_team text-center" v-if="$store.state.userDetail.count_warehouse === 1 && data_stock.stock_status === 0 || $store.state.userDetail.count_warehouse === 1 && data_stock.stock_status === 1 || $store.state.userDetail.count_warehouse === 1 && data_stock.stock_status === 2">
          <router-link class="menu_team_link" to="/stock/count_warehouse/countlistwarehouse">
            <div class="menu_team_img">
              <img src="@/assets/supply.png">
            </div>
            <div>
              ประวัติการนับสต๊อก
            </div>
          </router-link>
        </v-card>
        <v-card class="d-none menu_team text-center" v-else-if="$store.state.userDetail.count_warehouse === 0">
          <router-link class="menu_team_link" to="/stock/count_warehouse/countlistwarehouse">
            <div class="menu_team_img">
              <img src="@/assets/supply.png">
            </div>
            <div>
              ประวัติการนับสต๊อก
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center" v-else disabled>
          <router-link class="menu_team_link" to="/stock/count_warehouse/countlistwarehouse">
            <div class="menu_team_img">
              <img src="@/assets/supply.png">
            </div>
            <div>
              ประวัติการนับสต๊อก
            </div>
          </router-link>
        </v-card>
        <!-- สร้างรอบนับ -->
        <v-card class="menu_team text-center" v-if="$store.state.userDetail.count_warehouse_create === 1 && data_stock.stock_status === 2">
          <router-link class="menu_team_link" to="/stock/count_warehouse/warehousecreate">
            <div class="menu_team_img">
              <img src="@/assets/clipboard_1.png">
            </div>
            <div>
              สร้างรอบนับ
            </div>
          </router-link>
        </v-card>
        <v-card class="d-none menu_team text-center" v-else-if="$store.state.userDetail.count_warehouse_create === 0">
          <router-link class="menu_team_link" to="/stock/count_warehouse/warehousecreate">
            <div class="menu_team_img">
              <img src="@/assets/clipboard_1.png">
            </div>
            <div>
              สร้างรอบนับ
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center" v-else disabled>
          <router-link class="menu_team_link" to="/stock/count_warehouse/warehousecreate">
            <div class="menu_team_img">
              <img src="@/assets/clipboard_1.png">
            </div>
            <div>
              สร้างรอบนับ
            </div>
          </router-link>
        </v-card>
        <!-- นับสต๊อก -->
        <v-card class="menu_team text-center mr-1" v-if="$store.state.userDetail.count_warehouse_count === 1 && data_stock.stock_status !== 1 && data_stock.stock_status !== 2">
          <router-link class="menu_team_link" to="/stock/count_warehouse/warehousecount">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              นับสต๊อก
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center mr-1" v-if="$store.state.userDetail.count_warehouse_count === 1 && data_stock.stock_status !== 0" disabled>
          <router-link class="menu_team_link" to="/stock/count_warehouse/warehousecount">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              นับสต๊อก
            </div>
          </router-link>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "MenuCount_Storage",
  data() {
    return {
      data_stock: [],
      loading_page: false,
    }
  },
  methods: {
    async checkStock() {
      this.loading_page = true
      this.data_stock = []
      await HTTP.post('/inventory/counts/stocklatest')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              if (res.data.object.stock_status == null) {
                const val = {
                  stock_status: 2
                }
                this.data_stock = val
                if (this.$store.state.userDetail.count_warehouse === 0) {
                  if (this.$store.state.userDetail.count_warehouse_create === 1) {
                    this.$router.push('/stock/count_warehouse/warehousecreate')
                  }
                  else if (this.$store.state.userDetail.count_warehouse_count === 1 && this.data_stock.stock_status === 0) {
                    this.$router.push('/stock/count_warehouse/warehousecount')
                  }
                  else {
                    this.$router.push('/stock')
                  }
                }
                else if (this.$store.state.userDetail.count_warehouse === 1) {
                  if (this.$route.path == '/stock/count_warehouse/warehousecount' && this.data_stock.stock_status !== 0) {
                    this.$router.push('/stock/count_warehouse/countlistwarehouse')
                  }
                  else if (this.$route.path == '/stock/count_warehouse/warehousecreate' && this.data_stock.stock_status !== 2) {
                    this.$router.push('/stock/count_warehouse/countlistwarehouse')
                  }
                }
                else if (this.$store.state.userDetail.count_warehouse_count === 0) {
                  if (this.$route.path == '/stock/count_warehouse/warehousecount') {
                    this.$router.push('/stock/count_warehouse/countlistwarehouse')
                  }
                }
                else if (this.$store.state.userDetail.count_warehouse_create === 0) {
                  if (this.$route.path == '/stock/count_warehouse/warehousecreate') {
                    this.$router.push('/stock/count_warehouse/countlistwarehouse')
                  }
                }
              }
              else {
                this.data_stock = res.data.object;
                // catch สิทธิการใช้งานเมนู
                if (this.$store.state.userDetail.count_warehouse === 0) {
                  if (this.$store.state.userDetail.count_warehouse_create === 1 && this.data_stock.stock_status === 2) {
                    this.$router.push('/stock/count_warehouse/warehousecreate')
                  }
                  else if (this.$store.state.userDetail.count_warehouse_count === 1 && this.data_stock.stock_status === 0) {
                    this.$router.push('/stock/count_warehouse/warehousecount')
                  }
                  else {
                    this.$router.push('/stock')
                  }
                }
                else if (this.$store.state.userDetail.count_warehouse === 1) {
                  if (this.$route.path == '/stock/count_warehouse/warehousecount' && this.data_stock.stock_status !== 0) {
                    this.$router.push('/stock/count_warehouse/countlistwarehouse')
                  }
                  else if (this.$route.path == '/stock/count_warehouse/warehousecreate' && this.data_stock.stock_status !== 2) {
                    this.$router.push('/stock/count_warehouse/countlistwarehouse')
                  }
                }
                else if (this.$store.state.userDetail.count_warehouse_count === 0) {
                  if (this.$route.path == '/stock/count_warehouse/warehousecount') {
                    if (this.$store.state.userDetail.count_warehouse === 1) {
                      this.$router.push('/stock/count_warehouse/countlistwarehouse')
                    }
                    else {
                      this.$router.push('/stock')
                    }
                  }
                }
                else if (this.$store.state.userDetail.count_warehouse_create === 0) {
                  if (this.$route.path == '/stock/count_warehouse/warehousecreate') {
                    if (this.$store.state.userDetail.count_warehouse !== 0) {
                      this.$router.push('/stock/count_warehouse/countlistwarehouse')
                    }
                    else {
                      this.$router.push('/stock')
                    }
                  }
                }
              }
            }
          })
    },
  },
  mounted() {
    this.checkStock();
  },
}
</script>

<style scoped>
.grid_menu {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 1000px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 500px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
.menu_team {
  width: 97%;
}
.menu_team>.menu_team_link {
  color: #565656;
  padding: 10px 15px 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  font-size: 20px;
}
.router-link-active,
.menu_team>.menu_team_link:hover {
  color: #fff !important;
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d)!important;
  transition: 0.1s !important;
  border-radius: 4px;
  font-weight: 400;
}

.menu_team_img {
  margin: auto;
  width: 50px;
}

.menu_team_img>img {
  max-width: 100%;
}
</style>
